const lastRemainingMsByKey = new Map<string, number>();

export function clampToMonotonicRemainingMs(key: string, remainingMs: number): number {
  const prev = lastRemainingMsByKey.get(key);
  const clamped = prev === undefined ? remainingMs : Math.min(prev, remainingMs);
  lastRemainingMsByKey.set(key, clamped);

  if (lastRemainingMsByKey.size > 200) {
    const oldestKey = lastRemainingMsByKey.keys().next().value;
    if (oldestKey !== undefined) lastRemainingMsByKey.delete(oldestKey);
  }

  return clamped;
}
